import { Base } from "@app/controllers/base";
import { PaymentChannel } from "@app/channels/store/payment_channel";

// Connects to data-controller="store-page--payment"
export default class extends Base {
  static values = { code: String, expireUrl: String }
  
  connect() {
    console.log("Payment controller connected with code:", this.codeValue);
    this.subscriptions = {};
    this.subscribeChannel();
  }

  disconnect() {
    if (this.subscriptions.paymentChannel) {
      this.subscriptions.paymentChannel.disconnect();
      delete this.subscriptions.paymentChannel;
    }
  }

  async subscribeChannel() {
    this.paymentChannel = new PaymentChannel({
      channel: "Store::PaymentChannel",
      params: {
        code: this.codeValue,
      },
      attributes: {
        paymentController: this,
      }
    });

    this.subscriptions = {
      paymentChannel: await this.paymentChannel.subscribe(),
    }
  }

  handleMessage(data) {
    if (data.action === "payment_updated") {
      console.log(`Live update: Status=${data.status}, PaymentStatus=${data.payment_status}`);

      if (data.status === "expired") {
        window.location.href = this.expireUrlValue;
        return;
      }

      window.Turbo ? Turbo.visit(window.location.href, { action: "replace" }) : window.location.reload();
    }
  }
}
